import React, { useState } from 'react';
export function HabitsSection() {
  const [activeTab, setActiveTab] = useState(0);
  const habits = [{
    id: 0,
    title: 'The After‑Meal Trick',
    content: 'I discovered that moving for just 10 minutes after meals helps my body absorb sugar more effectively. No intense exercise needed—just a simple walk around the block or even light housework. My post-meal readings dropped by an average of 30 points when I added this habit! My endocrinologist later explained that physical movement helps your muscles use glucose without requiring additional insulin.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3rxGVSUaZCVGu9Z25ieiZk/after-meal-trick.jpg',
    alt: 'Woman walking down stairs after a meal'
  }, {
    id: 1,
    title: 'The Food Diary Revelation',
    content: "I started keeping a detailed food diary, recording not just what I ate but my blood sugar response 1-2 hours later. I was shocked to discover 'healthy' foods like whole grain cereal were spiking my blood sugar worse than my homemade cinnamon oatmeal. This personalized data helped me identify my unique triggers and safe foods, something no generic diet plan had ever provided.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1uWA1W2KCtVi1kWxY2voQU/food-diary.jpg',
    alt: 'Woman writing in her food diary in the evening'
  }, {
    id: 2,
    title: 'The $400/Month Spice Hunt',
    content: "My research led me to four natural ingredients with promising studies behind them: cinnamon bark, bitter melon, mulberry leaf, and juniper berry. Each showed potential for supporting healthy blood sugar levels, but sourcing high-quality versions of all four cost me nearly $400 monthly. While they helped, the expense and hassle of managing so many supplements wasn't sustainable long-term.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tgfEwejtWuRXSQTGUGnW8Q/spice-hunt.jpg',
    alt: 'Grocery receipt showing $400 monthly cost for natural ingredients'
  }, {
    id: 3,
    title: 'The Bedtime Routine',
    content: "I created a strict sleep ritual: no screens after 9 PM, a cup of herbal tea, and writing tomorrow's to-do list to clear my mind. This not only improved my sleep quality but virtually eliminated my late-night cravings for sweets. Better sleep also meant more stable morning blood sugar readings—something I'd struggled with for decades.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aHm3Vjnx7e6CPvtBm2qRCX/bedtime-routine.jpg',
    alt: 'Woman peacefully sleeping with an eye mask'
  }, {
    id: 4,
    title: 'The Pantry Reset',
    content: 'I completely overhauled my kitchen, removing processed foods and replacing them with blood sugar-friendly staples. Steel-cut oats, beans, brown rice, and frozen vegetables became my foundation. The first month was challenging, but soon my taste buds adjusted, and my cravings diminished. My grocery bill dropped by nearly 30%, and my A1C followed a similar downward trend.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2akhcmW1rLqmSeK4VWwNqt/pantry-reset.jpg',
    alt: 'Woman organizing her pantry with healthy staples in glass jars'
  }];
  return <section className="mb-16" data-id="element-72">
      <h2 className="text-2xl md:text-3xl font-bold text-emerald-800 mb-8" data-id="element-73">
        Five Habits That Changed My Life
      </h2>
      <div className="mb-6 overflow-x-auto" data-id="element-74">
        <div className="flex border-b border-gray-300 min-w-max" data-id="element-75">
          {habits.map((habit, index) => <button key={habit.id} onClick={() => setActiveTab(index)} className={`px-4 py-3 text-sm md:text-base font-medium transition-colors duration-200 ${activeTab === index ? 'text-emerald-700 border-b-2 border-emerald-700' : 'text-gray-600 hover:text-emerald-600'}`} data-id="element-76">
              {habit.title}
            </button>)}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-77">
        {habits.map((habit, index) => <div key={habit.id} className={`${activeTab === index ? 'block' : 'hidden'}`} data-id="element-78">
            <div className="flex flex-col md:flex-row" data-id="element-79">
              <div className="md:w-1/2 p-6" data-id="element-80">
                <h3 className="text-xl font-semibold text-emerald-700 mb-4" data-id="element-81">
                  {habit.title}
                </h3>
                <p className="text-gray-700" data-id="element-82">{habit.content}</p>
              </div>
              <div className="md:w-1/2 bg-gray-100" data-id="element-83">
                <img src={habit.image} alt={habit.alt} className="w-full h-64 md:h-full object-cover" data-id="element-84" />
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}